import { Field, Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import Title from "../../components/common/title/Title";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useEffect, useState, useRef } from "react";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import {
  priceCouponValidation,
  percentCouponValidation,
} from "../../utils/validations/couponValidation";
import { PiXSquareFill } from "react-icons/pi";
import RolesSelect from "../../components/common/inputs/RolesSelect";
import UsersSelect from "../../components/common/inputs/UsersSelect";
import DateInput from "../../components/common/inputs/DateInput";
import { convertDate } from "../../utils/convertDate";

export default function Coupon() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);
  const [forQueryParams, setForQueryParams] = useState([]);
  const [roles, setRoles] = useState([]);
  const [userIds, setUserIds] = useState([]);

  const [type, setType] = useState("price");
  const [isLimited, setIsLimited] = useState(
    location.state?.isLimited ? "1" : "0"
  );
  const [setFreeShipping, setSetFreeShipping] = useState(
    location.state?.setFreeShipping ? "1" : "0"
  );
  const [expireDate, setExpireDateDate] = useState(location.state?.expireDate);

  const formHandler = async (values, { resetForm }) => {
    const body = {
      ...values,
      expireDate,
      forQueryParams,
      type: type,
      isLimited: isLimited == "1",
      setFreeShipping: setFreeShipping == "1",
      value: Number(values.value),
      minPrice: Number(values.minPrice) || 0,
      maxPrice: Number(values.maxPrice) || 0,
      roles,
      userIds,
    };
    console.log(body);
    try {
      if (!location?.state) {
        const response = await postApi({
          path: "admin/coupons",
          body: JSON.stringify(body),
        });
        console.log(response);
        successMessage("کوپن با موفقیت اضافه شد");
        navigate("/coupon-list");
      } else {
        const response = await putApi({
          path: `admin/coupons/${location?.state._id}`,
          body: JSON.stringify(body),
        });
        console.log(response);
        successMessage("اطلاعات کوپن با موفقیت آپدیت شد.");
      }
      navigate("/coupon-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const [query, setQuery] = useState("");

  const addQuery = () => {
    if (query.length) {
      setForQueryParams((prev) => [...prev, query]);
      setQuery("");
    } else {
      warningMessage("لطفا مقدار کوئری را وارد کنید.");
    }
  };

  useEffect(() => {
    if (location?.state?.forQueryParams?.length) {
      setForQueryParams(location.state?.forQueryParams);
    }
    if (location?.state?.type) {
      setType(location.state?.type);
    }
    if (location?.state?.roles?.length) {
      setRoles(location?.state?.roles || []);
    }
    if (location?.state?.userIds?.length) {
      setUserIds(location?.state?.userIds || []);
    }
    if (!location.state) {
      reset();
    }
  }, [location.state]);

  const valueRef = useRef();
  const minPriceRef = useRef();
  const maxPriceRef = useRef();

  const reset = () => {
    valueRef.current.afterSubmit();
    minPriceRef.current.afterSubmit();
    maxPriceRef.current.afterSubmit();
    setForQueryParams([]);
    setQuery("");
    setType("price");
  };

  const deleteQuery = (index) => {
    let newQuery = [...forQueryParams];
    newQuery.splice(index, 1);
    setForQueryParams(newQuery);
  };

  const roleRef = useRef();

  const handleRoles = (e) => {
    setRoles(e);
  };

  const handleUsers = (e) => {
    setUserIds(e);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={!location?.state ? "افزودن کوپن" : "ویرایش کوپن"} />
      <Formik
        enableReinitialize
        initialValues={{
          name: location?.state?.name || "",
          code: location?.state?.code || "",
          type: location?.state?.type || "",
          value: location?.state?.value || "",
          status: location?.state?.status || "active",
          minPrice: location?.state?.minPrice || "",
          maxPrice: location?.state?.maxPrice || "",
          limit: location?.state?.limit,
          isLimited: location?.state?.isLimited || "0",
          setFreeShipping: location?.state?.setFreeShipping || "0",
          expireDate: location?.state?.expireDate || "",
          brand: location?.state?.brand || "attarbashi",
        }}
        validationSchema={
          type == "price" ? priceCouponValidation : percentCouponValidation
        }
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder={"نام"}
                  label="نام"
                  type="text"
                />
                <Input
                  name={"code"}
                  placeholder={"کد"}
                  label={"کد"}
                  type="text"
                />

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    محدودیت استفاده دارد ؟
                  </label>
                  <select
                    value={isLimited}
                    onChange={(e) => setIsLimited(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"1"}>بله</option>
                    <option value={"0"}>خیر</option>
                  </select>
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    رایگان برای حملو نقل؟
                  </label>
                  <select
                    value={setFreeShipping}
                    onChange={(e) => setSetFreeShipping(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"1"}>بله</option>
                    <option value={"0"}>خیر</option>
                  </select>
                </div>
                <Input
                  name={"limit"}
                  label={"تعداد مجاز (درصوت داشتن محدودیت)"}
                  placeholder={"تعداد مجاز استفاده"}
                  type="number"
                />
                <DateInput
                  label={`مقدار فعلی تاریخ انقضا ${
                    expireDate ? convertDate(expireDate) : "ندارد"
                  }`}
                  onChange={setExpireDateDate}
                />
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    نوع تخفیف
                  </label>
                  <select
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"percent"}>درصد</option>
                    <option value={"price"}>قیمت</option>
                  </select>
                </div>
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    مقدار
                  </label>
                  <CurrencyInput
                    placeholder="مقدار"
                    ref={valueRef}
                    name="value"
                    inputValue={formik.values["value"]}
                    onChange={(e) => formik.setFieldValue("value", e)}
                  />
                  {formik.errors.value && formik.touched.value ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.value}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    کف قیمت
                  </label>
                  <CurrencyInput
                    placeholder="کف قیمت"
                    ref={minPriceRef}
                    name="minPrice"
                    inputValue={formik.values["minPrice"]}
                    onChange={(e) => formik.setFieldValue("minPrice", e)}
                  />
                  {formik.errors.minPrice && formik.touched.minPrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.minPrice}
                    </p>
                  ) : null}
                </div>

                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    سقف قیمت
                  </label>
                  <CurrencyInput
                    placeholder="سقف قیمت"
                    ref={maxPriceRef}
                    name="maxPrice"
                    inputValue={formik.values["maxPrice"]}
                    onChange={(e) => formik.setFieldValue("maxPrice", e)}
                  />
                  {formik.errors.maxPrice && formik.touched.maxPrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.maxPrice}
                    </p>
                  ) : null}
                </div>
                <Field
                  as="select"
                  name="status"
                  label="وضعیت"
                  component={Select}
                >
                  {utils
                    ? utils?.COUPONS_STATUS_VALUES?.map((item) => {
                        return <option value={item.value}>{item.name}</option>;
                      })
                    : null}
                </Field>

                <Select
                  name="brand"
                  placeholder="برند"
                  label="برند"
                >
                  <option value={"attarbashi"}>عطارباشی</option>
                  <option value={"saboora"}>صبورا</option>
                </Select>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    انتخاب نقش
                  </label>
                  <RolesSelect
                    oldRoles={location?.state?.roles}
                    ref={roleRef}
                    onChange={handleRoles}
                  />
                </div>

                <div>
                  <UsersSelect
                    oldUsers={location?.state?.userIds}
                    onChange={handleUsers}
                    label="انتخاب کاربران خاص"
                  />
                </div>
              </div>

              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    کوئری
                  </label>
                  <input
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                </div>
                <div className="flex flex-col mt-8 gap-y-2">
                  <div className="">
                    <Button
                      onClick={addQuery}
                      type="button"
                      text={"افزودن"}
                      color={"primary"}
                    />
                  </div>
                </div>
              </div>

              <div className="flex items-center flex-wrap gap-3">
                {forQueryParams?.map((item, index) => {
                  return (
                    <button
                      type="button"
                      class="relative text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                    >
                      <PiXSquareFill
                        onClick={() => deleteQuery(index)}
                        size={26}
                        className={"absolute -top-2 -right-2 text-red-500"}
                      />
                      {item}
                    </button>
                  );
                })}
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="flex items-center gap-2 mt-6">
                  <Button
                    text={location?.state ? "ویرایش" : "افزون"}
                    color={"success"}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
